import { render } from "./TalentCard.vue?vue&type=template&id=f2d753fc&scoped=true"
import script from "./TalentCard.vue?vue&type=script&lang=js"
export * from "./TalentCard.vue?vue&type=script&lang=js"

import "./TalentCard.vue?vue&type=style&index=0&id=f2d753fc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d753fc"]])

export default __exports__